import * as S from './styles'
import { NhShape } from '@/assets/imgs'
import { Button, Image, Text } from '@/components'

export const ThankYouContainer: React.FC = () => (
  <S.ThankYouContainer>
    <Image src={NhShape} alt="logo nata" />
    <S.MessageContainer>
      <Text size="h4" align="center" className="message-text">
        Agradecemos o interesse e em breve faremos contato!
      </Text>
      <Button onClick={() => window.open('https://natahouse.com', '_self')}>
        <Text size="h5" className="button-text">
          Visite o nosso site
        </Text>
      </Button>
    </S.MessageContainer>
  </S.ThankYouContainer>
)
